import Autoplay from 'embla-carousel-autoplay';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { Carousel, useCarousel, CarouselDotButtons } from 'src/components/carousel';

// ----------------------------------------------------------------------

type Props = {
  data: {
    id: string;
    title: string;
    coverUrl: string;
    description: string;
  }[];
};

export function CarouselAutoplay({ data }: Props) {
  const carousel = useCarousel({ loop: true }, [Autoplay({ playOnInit: true, delay: 5000 })]);

  return (
    <Box sx={{ position: 'relative' }}>
      <Carousel carousel={carousel} sx={{ borderRadius: 2 }}>
        {data.map((item, index) => (
          <CarouselItem key={item.id} index={index} item={item} />
        ))}
      </Carousel>

      <CarouselDotButtons
        scrollSnaps={carousel.dots.scrollSnaps}
        selectedIndex={carousel.dots.selectedIndex}
        onClickDot={carousel.dots.onClickDot}
        sx={{
          top: '110%',
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
          color: 'common.white',
        }}
      />
    </Box>
  );
}

// ----------------------------------------------------------------------

type CarouselItemProps = {
  index: number;
  item: Props['data'][number];
};

function CarouselItem({ item, index }: CarouselItemProps) {
  return (
    <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box component="img" alt={item.title} src={item.coverUrl} sx={{ objectFit: 'cover', width: '400px' }} />
      <Typography
        variant="h4"
        sx={{ color: 'common.white', textAlign: 'center', whiteSpace: 'wrap', fontWeight: 500, mt: 2 }}
      >
        {item.title}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: 'common.white', textAlign: 'center', whiteSpace: 'wrap', fontWeight: 400 }}
      >
        {item.description}
      </Typography>
    </Box>
  );
}
